export const parseDate = (dateString: string) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(
    dateString.includes('Z') ? dateString : `${dateString}Z`
  );
  return date;
};
